import Vue from 'vue';
import VueI18n from 'vue-i18n';
import TranslationsService from '@/commons/services/TranslationsService';

/**
 * @description The overrides below do not impact Vue's template `$t`, which still consumes the original model.
 * That could be changed easily but it's just not worth the effort.
 *
 * These overloads come from VueI18n's source code, with two key changes:
 *
 * 1. The return value is always a string, instead of VueI18n's custom TranslateResult, which causes issues accross
 * the entire app.
 */

type CustomVueI18n = Omit<VueI18n, "t"> & {
  t(key: VueI18n.Path, values?: VueI18n.Values): string;
  t(key: VueI18n.Path, locale: VueI18n.Locale, values?: VueI18n.Values): string;
};

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true
}) as CustomVueI18n;

/*
  Gets the JSON translations for the current language
*/
export default async function getI18nConfig(language: string): Promise<CustomVueI18n> {
  const translationsService = new TranslationsService();

  const translations = await translationsService.getTranslations(language);

  i18n.setLocaleMessage(language, translations);
  i18n.locale = language;
  return i18n;
};
